import {call, put, select} from '@redux-saga/core/effects';
import {DialogTypes} from 'common/names';
import {asyncSagaConstructor} from 'redux/common';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';
import {licenseSelectors} from 'redux/license';
import {LICENSE_UNLIMITED} from 'redux/license/selectors';
import {DiplomatKeyType} from 'types/diplomat/keys/DiplomatKeyType';
import {api} from '_fake_backend/apiConstants';
import {keyTypes} from '..';
import {KeyUsageDialogProps} from 'components/dialogs/KeyUsageDialog';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import {KEY_USAGE_PCT} from 'common/constants';
import {pushErrorToast} from 'features/notifications/redux/actions';

export function* checkKeyUse(keyType: DiplomatKeyType, numToAdd: number) {
   try {
      const numAllowed: number = (yield select(
         licenseSelectors.getNumberKeysAllowed
      )) as ReturnType<typeof licenseSelectors.getNumberKeysAllowed>;
      if (numAllowed !== LICENSE_UNLIMITED) {
         const numUsedUrl =
            keyType == DiplomatKeyType.PGP
               ? api.usedPgpKeys
               : keyType == DiplomatKeyType.SSH
               ? api.usedSshKeys
               : api.usedSslKeys;

         const {used: numUsed} = yield call(
            asyncSagaConstructor(numUsedUrl, keyTypes.GET_USED_PGP_KEYS)
         );

         const data = {keyType} as KeyUsageDialogProps['data'];
         if (numUsed + numToAdd >= numAllowed) {
            data.numUsed = numUsed;
            data.numAllowed = numAllowed;
         } else {
            const pct = Math.ceil((numUsed / numAllowed) * 100); // TODO check
            if (pct >= KEY_USAGE_PCT) {
               data.pct = pct;
            }
         }

         // const res: ICloseSubDialogAction<boolean> =
         yield call(openDialogWithResult, {
            id: DialogTypes.KeyUsageDialog.id,
            data,
         });
         // checkKeyUsage = !res.payload?.data;
      }
   } catch (exc) {
      const typeText = keyType === DiplomatKeyType.SSL ? 'certificate' : 'key';
      yield put(
         pushErrorToast('Error requesting ' + typeText + ' usage: ' + (exc as Error).message)
      );
   }
}
